<template>
    <div>
        <label v-if="label" :for="`date_${label}`" :style="getStyle">{{ label }}</label>
        <input type="date" :id="`date_${label}`" :value="formattedValue" @input="onInput" :min="getMin" :max="getMax" :disabled="disabled" />
    </div>
</template>
<script>
import { moment } from "@/utils/moment";

export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
            required: false
        },
        value: {
            required: true
        },
        label: {
            type: String,
            required: false
        },
        required: {
            type: Boolean,
            default: false,
            required: false
        },
        min: {
            type: String,
            default: null,
            required: false
        },
        max: {
            type: String,
            default: null,
            required: false
        },
        errorMessage: {
            type: String,
            required: false
        },
        labelWidth: {
            type: Number,
            required: false,
            default: null
        }
    },
    computed: {
        // Retourne la date de this.value au format 'YYYY-MM-DD'
        formattedValue() {
            if (this.value === null) {
                return null;
            }

            return moment(this.value).format("YYYY-MM-DD");
        },
        getMin() {
            if (this.min) {
                return this.min;
            } else {
                return null;
            }
        },
        getMax() {
            if (this.max) {
                return this.max;
            } else {
                return null;
            }
        },
        getStyle() {
            return {
                "min-width": this.labelWidth + "px"
            };
        }
    },
    methods: {
        onInput(event) {
            if (!this.disabled) {
                this.$emit("input", this.createDate(event.target.value));
            }
        },
        createDate(dateString) {
            return moment(dateString);
        }
    }
};
</script>
<style lang="scss" scoped>
label {
    font-family: Roboto, Sans-Serif;
    font-weight: bold;
    font-size: 1.19em;
    margin-right: 15px;
}

input[type="date"] {
    cursor: pointer;
    width: 128px;

    // Icone de calendrier à droite de l'input
    &::-webkit-calendar-picker-indicator {
        cursor: pointer;
    }

    &:disabled {
        cursor: not-allowed;
    }
}
</style>



// WEBPACK FOOTER //
// Datepicker.vue?c4227cc8